import { render, staticRenderFns } from "./VipOrderList.vue?vue&type=template&id=0405e736&scoped=true"
import script from "./VipOrderList.vue?vue&type=script&lang=js"
export * from "./VipOrderList.vue?vue&type=script&lang=js"
import style0 from "./VipOrderList.vue?vue&type=style&index=0&id=0405e736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405e736",
  null
  
)

export default component.exports